import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import BrMultistateCheckboxDropdown from '@components/BrMultistateCheckboxDropdown';
import BulkActionApplier from './BulkActionApplier';

export default class RowSelector extends PureComponent {
  static propTypes = {
    selectedRows: PropTypes.array.isRequired,
    onHandleBatchSelect: PropTypes.func.isRequired,
    useDefaultRowConfigValues: PropTypes.bool.isRequired,
    totalDataLength: PropTypes.number.isRequired,
    useBulkActions: PropTypes.bool.isRequired,
    selectRowConfig: PropTypes.shape({
      batchSelectOptions: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.any.isRequired, // unique key
          title: PropTypes.string.isRequired, // option display text
          condition: PropTypes.func.isRequired, // data row will be passed as param  (row) => {}
        }),
      ),
      batchSelectActions: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.any.isRequired, // unique key
          title: PropTypes.string, // option display text
          value: PropTypes.any, // if options not provided, this will become a standalone button
          onClick: PropTypes.func, // (selectedRows:array, actionItem:{key,value}) => {}
          options: PropTypes.arrayOf(
            PropTypes.shape({
              value: PropTypes.any.isRequired,
              title: PropTypes.string.isRequired,
              onClick: PropTypes.func, // this will be called instead of onBatchSelectActions if provided.
              // (selectedRows:array, actionItem:{key,value}) => {}
            }),
          ),
        }),
      ),
      onClickAction: PropTypes.func, // (selectedRows:array, actionItem:{key,value}) => {}
    }),
  };

  filterOutReadOnlyData(displayData) {
    if (displayData === null || displayData?.length === 0) {
      return [];
    }
    return displayData.filter((data) => {
      const { isEditable, isLive } = data.Original_Data;
      return !(!isEditable || isLive);
    });
  }

  render() {
    const {
      selectedRows,
      onHandleBatchSelect,
      selectRowConfig: { batchSelectOptions, batchSelectActions },
      selectRowConfig,
      displayData,
      useDefaultRowConfigValues,
      totalDataLength,
      useBulkActions,
    } = this.props;

    const rowIdsDisplayed = displayData.map((row) => row.id?.value) || [];
    const selectedLen = selectedRows.filter((row) => rowIdsDisplayed.includes(row.id.value)).length;
    let batchSelectionOptions = [];
    if (useBulkActions) {
      const displayReadOnlyData = this.filterOutReadOnlyData(displayData);
      batchSelectionOptions = displayReadOnlyData && batchSelectOptions?.map((option) => {
        if (option.key === 'Partial') {
          option.title = `Select page (${displayReadOnlyData.length})`;
        }
        if (option.key === 'All') {
          option.title = `Select all (${totalDataLength})`;
        }
        return option;
      });
    }

    return (
      <div className="br-table-data-selector">
        <>
          <BrMultistateCheckboxDropdown
            batchSelectOptions={batchSelectionOptions?.length > 0 ? batchSelectionOptions : batchSelectOptions}
            onBatchSelect={onHandleBatchSelect}
            selectableLength={useBulkActions ? totalDataLength : displayData.length}
            selectedLength={useBulkActions ? selectedRows.length : selectedLen}
            useDefaultRowConfigValues={useDefaultRowConfigValues}
            useBulkActions={useBulkActions}
          />
          {selectedRows?.length > 0 && batchSelectActions.map((actionGroup) => (
            <BulkActionApplier
              selectRowConfig={selectRowConfig}
              selectedRows={selectedRows}
              actionGroup={actionGroup}
              key={actionGroup.key}
              useBulkActions={useBulkActions}
            />
          ))}
        </>
      </div>
    );
  }
}
